import { ADMIN_STATE_KEY } from "~/admin";
import { STEERING_DATA_KEY, ISteeringDataState } from "./reducer";

const getModuleState = (state): ISteeringDataState => state[ADMIN_STATE_KEY][STEERING_DATA_KEY];

export const getSteeringDataScreenActive = (state) => getModuleState(state).screenActive;
export const getSteeringDataRecords = (state) => getModuleState(state).records;
export const getSelectedSteeringDataRecord = (state) => getModuleState(state).selectedRecord;
export const getSteeringDataLoading = (state) => getModuleState(state).loading;
export const getSteeringDataError = (state) => getModuleState(state).error;

// Per-parent child sublist state (children of a url-files parent). Returns a
// stable empty state when the parent's children have not been fetched yet.
const EMPTY_CHILD_STATE = { children: [], loading: false, error: null };
export const getSteeringDataChildrenState = (state, parentGuid: string) =>
    getModuleState(state).childrenByParent[parentGuid] ?? EMPTY_CHILD_STATE;

// The parent guids whose child sublists are currently loaded (i.e. an open
// Files sublist). Used to refresh those sublists when the list changes.
export const getLoadedChildParentGuids = (state): string[] =>
    Object.keys(getModuleState(state).childrenByParent);
